/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { defaultTheme } from '@vital-ui/react-theme';
import ModalWrapper from './ModalWrapper';
var isBrowser = typeof window !== 'undefined';
var OverLay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  z-index: 9999;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  opacity: 0.5;\n"], ["\n  background-color: ", ";\n  z-index: 9999;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  opacity: 0.5;\n"])), function (props) { return props.theme.grey800; });
OverLay.defaultProps = {
    theme: defaultTheme,
};
export function Modal(_a) {
    var _b = _a.show, show = _b === void 0 ? false : _b, props = __rest(_a, ["show"]);
    var getNode = function () { return props.mountElement || document.body; };
    if (!show || !isBrowser) {
        return null;
    }
    return ReactDOM.createPortal(React.createElement("div", { className: "vital__modal" },
        React.createElement(OverLay, null),
        React.createElement(ModalWrapper, null, React.Children.only(props.children))), getNode());
}
var templateObject_1;
//# sourceMappingURL=Modal.js.map